export enum NOTIFICATION_TYPE {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  NEUTRAL = 'neutral',
}

export enum NOTIFICATION_ICONS {
  SUCCESS = 'checkCircle',
  ERROR = 'closeCircle',
  INFO = 'alertCircle',
  NEUTRAL = 'info',
}
